/**
 * Novel Detail - 共用類型
 */

import type { Chapter, Novel } from '../../services/types';

export interface ChapterItemProps {
  chapter: Chapter;
  novelId: string;
  isLastRead: boolean;
  isAdmin: boolean;
  isUploadedNovel: boolean;
  isEditMode: boolean;
  isSelected: boolean;
  onEditContent: (chapter: Chapter) => void;
  onRecrawl: (chapter: Chapter) => void;
  onSkip: (chapter: Chapter) => void;
  onMoveUp?: (chapter: Chapter) => void;
  onMoveDown?: (chapter: Chapter) => void;
  onDelete: (chapter: Chapter) => void;
  onToggleSelect: (chapterId: string) => void;
  isRecrawling: boolean;
  isSkipping: boolean;
  isFirst?: boolean;
  isLast?: boolean;
}

export interface SeriesNovelCardProps {
  novel: Novel;
  isCurrent: boolean;
}

export interface ChapterGroup {
  start: number;
  end: number;
  chapters: Chapter[];
}

// 統一狀態配置 - 使用語義化顏色
export const statusConfig: Record<string, { badge: string; label: string }> = {
  pending: { badge: 'badge-neutral', label: '等待中' },
  crawling: { badge: 'badge-primary', label: '下載中' },
  completed: { badge: 'badge-success', label: '已完成' },
  failed: { badge: 'badge-danger', label: '失敗' },
  paused: { badge: 'badge-warning', label: '已暫停' },
};

export const CHAPTERS_PER_GROUP = 50;
